<div #imgBlock class="ba-studisu-signet" style="display: none">
  <!-- STUDISU-1294 *ngIf sollte hier nicht verwendet werden, da @ViewChild damit Probleme hat. Daher diese Konstruktion. -->
  <img
    [src]="hasSignet ? getImageUrl() : ''"
    (load)="loadingComplete()"
    alt="Logo des Studienanbieters"
  />
</div>
<div class="ba-studisu-signet ba-icon ba-icon-diploma-before" *ngIf="!loaded"></div>
